import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { userAtom } from '../store/atoms';
import { telemetry } from '../services/persera-telemetry-browser';
import { useImpersonation } from '../hooks/useImpersonation';

/**
 * Page views and client errors for the Persera hub (Admin → Telemetry), so funnels can follow a visitor from the
 * landing page into a crew. persera-telemetry-browser.ts is the hub's SDK, copied as-is. Paths are sent as templates
 * (ids become ":id").
 *
 * GDPR: nothing is collected or stored until the cookie banner is accepted. Nothing is recorded while an admin is
 * impersonating someone, so their clicks are never attributed to that person.
 */
telemetry.init({
    consent: () => {
        try {
            return localStorage.getItem('cookie') === 'accepted';
        } catch {
            return false;
        }
    },
});

export const TelemetryTracker = () => {
    const { pathname } = useLocation();
    const user = useAtomValue(userAtom);
    const { isImpersonating } = useImpersonation();

    React.useEffect(() => {
        telemetry.identify(user?.guid);
    }, [user?.guid]);

    React.useEffect(() => {
        if (!isImpersonating) {
            telemetry.page(pathname);
        }
    }, [pathname, isImpersonating]);

    return null;
};
